import script from "./TextHoverEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./TextHoverEffect.vue?vue&type=script&setup=true&lang=js"

import "./TextHoverEffect.vue?vue&type=style&index=0&id=2fc94a29&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fc94a29"]])

export default __exports__